<template>
  <div class="container" v-show="slopeFromState.slopeType !== ''
                                 && slopeFromState.materialSize !== ''
                                 && slopeFromState.materialSize.width === 0">
    <div class="slopePage__title">
      Material selection for a <span v-if="type === 'mainSlope'">main slope</span>
      <span v-else>counter slope</span>
    </div>
    <div class="slopePage__filter">
      <label for="all" class="slopePage__filter-item" :class="{'active': filter === ''}"
             v-if="allMaterialsTypes.length > 1">
      <input type="radio" v-model="filter" id="all" value="">
        <span>All materials</span>
      </label>
      <label :for="item.name"
             v-for="(item, i) in allMaterialsTypes"
             :key="i"
             class="slopePage__filter-item"
             :class="{'active': filter === item.name || allMaterialsTypes.length === 1}">
        <input type="radio" v-model="filter" :id="item.name" :value="item.name">
        <span>{{ item.name }}</span>
      </label>
    </div>
    <div class="slopePage__materials">
      <label v-for="material in filteredMaterials"
             :key="material.id"
             class="slopePage__materials-item"
             :for="material.id"
             :class="{'slopePage__materials-item--active':
             slopeFromState.material === material.id,
             showInfo: showMaterialInfo === material.id}">
        <input type="radio"
               :id="material.id"
               :value="material.id"
               v-model="slopeFromState.material"
               @change="setSlopeMaterial">
          <img :src="material.src" alt="" class="slopePage__materials-item--img">
          <div class="slopePage__materials-item--name">{{ material.name }}</div>
          <div class="slopePage__materials-item--footer">
            <div class="slopePage__materials-item--angle">
              <img src="@/assets/img/angle.svg" alt="">{{ material.angle }}%</div>
            <label :for="`material-${material.id}`">
              <input type="radio"
                     :value="material.id"
                     :id="`material-${material.id}`"
                     v-model="showMaterialInfo">
                <img src="@/assets/img/info.svg" alt="info">
            </label>
          </div>
          <div class="slopePage__materials-item--variants">
            <button @click="slopeFromState.material = ''" class="close">
              <svg width="16" height="16" viewBox="0 0 16 16"
               fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M1 15L15 1M15 15L1 1" stroke="#C9C9C9"
                stroke-width="1.9998" stroke-miterlimit="22.9256" stroke-linejoin="round"></path>
              </svg>
            </button>
            <div class="slopePage__materials-item--variants__title">
              Select <br>panel size
            </div>
            <label :for="param.id" v-for="param in material.params" class="btn" :key="param.id">
              <input type="radio"
                     :value="param"
                     v-model="pickedMaterialParam"
                     :id="param.id"
                     @change="setSlopeMaterialSizes">
              {{ param.width }}x{{ param.height }}
            </label>
          </div>
          <div class="slopePage__materials-item--info" v-show="showMaterialInfo === material.id">
            <button class="close" @click="showMaterialInfo = ''">
              <img src="@/assets/img/close-red.svg" alt="close"></button>
            <div class="title">
              {{ material.name }}
            </div>
            <div class="angle">
              <div class="slopePage__materials-item--angle">
                <img src="@/assets/img/angle.svg" alt="">{{ material.angle }}%</div>
            </div>
            <div class="params">
              <div class="params__item"
                   v-for="param in material.params"
                   :key="param.id">{{ param.width }}x{{ param.height }} mm
              </div>
              <div class="params__divider">|</div>
            </div>
            <div class="text">{{ material.info_text }}</div>
            <div class="info" v-for="(plate, i) in material.plates" :key="i">
              <div class="info__name">
                {{ plate.name }}
              </div>
              <div class="info__val">
                {{ plate.value }}
              </div>
            </div>
            <a :href="material.link" target="_blank" class="link">
              <img src="@/assets/img/planet.svg" alt="planet">more</a>
          </div>
        </label>
        <button @click="showMore()" v-show="isFilter && remainingMaterials !== 0" class="showMore">
          <span><b>+{{ remainingMaterials }}</b> {{ word }}</span>
          <span class="slopePage__materials-item--angle">
            <img src="@/assets/img/angle.svg" alt="">
            <span v-if="type === 'mainSlope'">4,2</span><span v-else>1.7</span>%
          </span>
          </button>
      </div>
  </div>
</template>

<script>

export default {
  props: {
    type: String,
    isFilter: Boolean,
  },
  data() {
    return {
      pickedMaterialParam: '',
      showMaterialInfo: '',
      showedAngle: 1.7,
      filter: '',
      // isFilter: true,
      /* eslint-disable import/no-unresolved */
      /* eslint-disable global-require */
      materials: [],
      /* eslint-enable import/no-unresolved */
      /* eslint-enable global-require */
    };
  },
  methods: {
    setSlopeMaterial() {
      this.$store.commit('updateSlopeMaterial', { id: this.slopeId, material: this.slopeFromState.material });
      this.pickedMaterialParam = '';
    },
    setSlopeMaterialSizes() {
      this.$store.commit('updateSlopeMaterialSizes', { id: this.slopeId, sizes: this.pickedMaterialParam });
    },
    showMore() {
      this.$emit('showMore');
    },
  },
  mounted() {
    if (this.allMaterialsTypes.length === 1) {
      this.filter = this.allMaterialsTypes[0].name;
    }
    // this.materials = cloneDeep(this.allMaterials);
    // this.isFilter = true;
  },
  watch: {
  },
  computed: {
    filteredMaterials() {
      return this.currentMaterials.filter(material => material.type.match(this.filter));
    },
    filteredAllMaterials() {
      return this.allMaterials.filter(material => material.type.match(this.filter));
    },
    currentMaterials() {
      if (this.isFilter) {
        return this.allMaterials.filter(material => material.slope.match(this.type));
      }
      return this.allMaterials;
    },
    remainingMaterials() {
      return this.filteredAllMaterials.length - this.filteredMaterials.length;
    },
    word() {
      // const cases = [2, 0, 1, 1, 1, 2];
      // const words = ['material', 'materials', 'materials'];
      return this.remainingMaterials > 1 ? 'materials' : 'material';
      // return words[(this.remainingMaterials % 100 > 4
      //                 && this.remainingMaterials % 100 < 20) ? 2
      //   : cases[(this.remainingMaterials % 10 < 5)
      //     ? this.remainingMaterials % 10 : 5]];
    },
    typeFromState() {
      return this.slopeFromState.SlopeType;
    },
    slopeFromState() {
      return this.$store.getters.getSlope(this.slopeId);
    },
    slopeId() {
      return (this.$route.params.id) ? this.$route.params.id : 0;
    },
    allSlopes() {
      return this.$store.getters.allSlopes;
    },
    allMaterials() {
      return this.$store.getters.allMaterials;
    },
    allMaterialsTypes() {
      return this.$store.getters.allMaterialsTypes;
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="sass">
.slopePage
  &__title
    margin-left: rem(-15)
    padding-bottom: rem(16)
  &__materials
    display: grid
    grid-template-rows: 1fr
    grid-column-gap: rem(1)
    grid-row-gap: rem(1)
    margin-left: rem(-15)
    margin-right: rem(-15)
    +media((grid-template-columns: (320: repeat(2, 1fr), 650: repeat(3, 1fr), 992: repeat(4, 1fr))))
    &-item
      background: #fff
      +media((padding: (320: rem(12) rem(12) rem(15), 768: rem(17) rem(26) rem(20))))
      text-align: left
      transition: .5s
      z-index: 1
      cursor: pointer
      position: relative
      img
        max-width: 100%
        margin: auto
        display: block
        max-height: rem(101)
      input[type="radio"]
        position: absolute
        opacity: 0
        pointer-events: none
      &:hover
        box-shadow: 0 rem(4) rem(14) rgba(0, 0, 0, 0.16)
        z-index: 2
        .slopePage__materials-item--img
          opacity: .7
      &.showInfo
        z-index: 2
      &--active
        .slopePage__materials-item--variants
          opacity: 1
          pointer-events: auto
      &--img
        transition: .5s
      &--name
        font-style: normal
        font-weight: 600
        font-size: rem(14)
        color: $red
        +media((min-height: (320: rem(64), 370: rem(42), 768: rem(52))))
        +media((padding-top: (320: rem(20), 768: rem(18))))
        +media((line-height: (320: rem(22), 768: rem(17))))
      &--angle
        font-style: normal
        font-weight: bold
        font-size: rem(14)
        line-height: rem(17)
        //padding-top: rem(6)
        color: $black
        display: flex
        flex-direction: row
        align-items: center
        img
          padding-right: rem(6)
          margin: 0
      &--footer
        padding-top: rem(6)
        display: flex
        flex-direction: row
        align-items: center
        justify-content: space-between
        label
          line-height: 0
          cursor: pointer
      &--variants
        height: 100%
        width: 100%
        opacity: 0
        transition: .5s
        background: rgba(51, 51, 51, 0.88)
        pointer-events: none
        position: absolute
        left: 0
        top: 0
        display: flex
        flex-direction: column
        align-items: center
        &__title
          font-style: normal
          font-weight: bold
          font-size: rem(14)
          line-height: rem(20)
          color: #FFFFFF
          text-align: center
          +media((padding-top: (320: rem(28), 768: rem(34))))
          +media((padding-bottom: (320: rem(21), 768: rem(24))))
        .close
          cursor: pointer
          border: none
          background: none
          box-shadow: none
          margin: 0
          padding: 0
          line-height: 0
          padding: rem(11)
          position: absolute
          right: 0
          top: 0
          outline: none
          svg
            path
              transition: .5s
          &:hover
            svg
              path
                stroke: $red
        .btn
          border-radius: rem(4)
          font-style: normal
          font-weight: 500
          font-size: rem(14)
          line-height: rem(16)
          padding: rem(8)
          width: rem(120)
          text-align: center
          margin-bottom: rem(10)
          transition: .5s
          cursor: pointer
          +media((background: (320: $red, 768: #ECECEC)))
          +media((color: (320: #fff, 768: $black)))
          &:hover
            background: $red
            color: #fff
          input[type="radio"]
            position: absolute
            opacity: 0
            pointer-events: none
      &--info
        background: #fff
        box-shadow: 0 rem(4) rem(14) rgba(0, 0, 0, 0.16)
        border-radius: rem(4)
        +media((position: (320: fixed, 480: absolute)))
        top: 50%
        transform: translateY(-50%)
        z-index: 3
        left: 0
        right: 0
        margin: auto
        padding: rem(16) rem(20) rem(18)
        color: $black
        transition: .5s
        +media((width: (320: 80vw, 380: 70vw, 410: 60vw, 480: 100%)))
        +media((box-shadow: (320: 0 0 rem(10) rem(500) rgba(0, 0, 0, 0.62),
        480: 0 rem(4) rem(14) rgba(0, 0, 0, 0.16))))
        .title
          font-style: normal
          font-weight: 500
          font-size: rem(14)
          line-height: rem(17)
          color: #333333
          padding-bottom: rem(5)
          padding-right: rem(10)
        .params
          font-style: normal
          font-weight: bold
          font-size: rem(12)
          line-height: rem(20)
          display: flex
          flex-direction: row
          align-items: center
          padding-top: rem(18)
          padding-bottom: rem(6)
          &__item
            position: relative
            padding-right: rem(4)
            order: 3
            &:first-of-type
              order: 1
              //&:after
                content: "|"
                color: $red
                position: absolute
                right: rem(8)
          &__divider
            color: $red
            order: 2
            padding-right: rem(4)
        .text
          font-style: normal
          font-weight: 500
          font-size: rem(12)
          line-height: rem(18)
          color: #999999
          padding-bottom: rem(17)
        .info
          display: flex
          flex-direction: row
          align-items: center
          padding-bottom: rem(5)
          &__name
            font-style: normal
            font-weight: 500
            font-size: rem(12)
            line-height: rem(20)
            color: #5C5C5C
            width: rem(120)
          &__val
            font-style: normal
            font-weight: 600
            font-size: rem(12)
            line-height: rem(20)
            color: #5C5C5C
        .link
          color: $red-hover
          font-style: normal
          font-weight: 500
          font-size: rem(12)
          line-height: rem(20)
          display: flex
          align-items: center
          flex-direction: row
          text-decoration: none
          padding-top: rem(14)
          img
            padding-right: rem(12)
            margin: 0
          &:hover
            text-decoration: underline
        .close
          border: none
          box-shadow: none
          outline: none
          cursor: pointer
          background: none
          padding: 0
          margin: 0
          line-height: 0
          padding: rem(13)
          position: absolute
          top: 0
          right: 0
  &__filter
    border-bottom: rem(1) solid #C9C9C9
    display: flex
    flex-direction: row
    align-items: center
    justify-content: flex-start
    margin-left: rem(-15)
    margin-right: rem(-15)
    margin-bottom: rem(34)
    overflow-x: auto
    overflow-y: hidden
    +media((margin-left: (320: rem(9), 768: 0)))
    &-item
      font-style: normal
      font-weight: bold
      font-size: rem(14)
      line-height: rem(17)
      display: flex
      color: #5C5C5C
      cursor: pointer
      transition: .5s
      position: relative
      +media((padding-right: (320: rem(20), 768: rem(30))))
      box-sizing: content-box
      span
        position: relative
        display: block
        height: 100%
        padding: rem(25) 0
        white-space: nowrap
      input[type="radio"]
        position: absolute
        opacity: 0
        pointer-events: none
      &.active
        color: $black
        span
          &:after
            content: ""
            position: absolute
            left: 0
            bottom: rem(-1)
            width: 100%
            height: rem(4)
            background: $red
.showMore
  background: none
  box-shadow: none
  border: none
  outline: none
  background: rgba(255, 255, 255, 0.5)
  border: rem(1) solid #C9C9C9
  box-sizing: border-box
  border-radius: rem(4)
  border-style: dashed
  font-family: $main-font
  font-style: normal
  font-weight: 500
  font-size: rem(14)
  line-height: rem(17)
  display: flex
  flex-direction: column
  justify-content: center
  align-items: center
  text-align: center
  color: #E30713
  cursor: pointer
  padding: 0
  margin: rem(20)
  min-height: rem(164)
  span
    padding-bottom: rem(2)
    padding-top: rem(2)
</style>
